<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 24 24"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect :fill="background" height="24" width="24"/>
    <circle cx="16.5" cy="10.5" r="4" :stroke="arrowFill"/>
    <path d="M13.7879 0.821095C14.6915 0.692002 15.5 1.39319 15.5 2.30602L15.5 21.694C15.5 22.6068 14.6915 23.308 13.7879 23.1789L3.78787 21.7503C3.04889 21.6448 2.5 21.0119 2.5 20.2654L2.5 3.73459C2.5 2.98812 3.04889 2.35523 3.78787 2.24967L13.7879 0.821095Z" :fill="background" :stroke="fill"/>
    <rect :fill="background" height="5" width="3" x="14" y="12"/>
    <path d="M10 18L7 14.5L10 11" :stroke="arrowFill" stroke-linecap="round"/>
    <line :stroke="arrowFill" transform="matrix(-1 8.74227e-08 8.74227e-08 1 17 15)" x2="10" y1="-0.5" y2="-0.5"/>
    <rect :fill="background" height="10" width="2" x="16" y="3"/>
  </svg>

</template>

<script>
export default {
  name: 'Flip',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    background: {
      type: String,
      required: false,
      default: '#FFF'
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
    arrowFill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
